/*import "./home.scss";*/

import HomeView from "../views/HomeView";

const Home = () => {
    return <div style={{ marginTop: -10 }}>
        <HomeView />
    </div>
};

export default Home;